import { render, staticRenderFns } from "./new_account_page.vue?vue&type=template&id=8c0aaa4e&"
import script from "./new_account_page.vue?vue&type=script&lang=js&"
export * from "./new_account_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports